import { useMemo } from "react";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import MediaCard from "@/components/feature/MediaCard";
import EmptyState from "@/components/feature/EmptyState";
import { useFavorites } from "@/hooks/useFavorites";
import { getMediaById, type Media } from "@/utils/media";

export default function FavoritesPage() {
  const { ids } = useFavorites();

  useDocumentMeta({
    title: "我的收藏 - 亚洲一区二区在线",
    description: "查看你在亚洲一区二区在线收藏的亚洲电影、电视剧与综艺节目。",
    keywords: "我的收藏,影视收藏,亚洲电影,亚洲电视剧,亚洲一区二区在线",
  });

  const items = useMemo(
    () =>
      ids
        .map((id) => getMediaById(id))
        .filter((item): item is Media => Boolean(item)),
    [ids],
  );

  return (
    <div className="mx-auto w-full px-4 py-6 md:px-6 md:py-8">
      <h1 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        <i className="ri-heart-3-line text-accent-500"></i>
        我的收藏
      </h1>
      <p className="mt-1 text-sm text-foreground-500">
        共收藏 <strong className="text-accent-600">{items.length}</strong> 部作品，收藏状态会保存在当前浏览器中
      </p>

      <div className="mt-6">
        {items.length > 0 ? (
          <div className="grid grid-cols-2 gap-3 md:gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {items.map((media) => (
              <MediaCard key={media.id} media={media} />
            ))}
          </div>
        ) : (
          <EmptyState
            icon="ri-heart-line"
            title="还没有收藏任何影视内容"
            description="在影视详情页点击「收藏」按钮，就能把喜欢的作品加入这里，随时回来查看。"
            actionLabel="去发现影视作品"
            actionTo="/category/movie"
          />
        )}
      </div>
    </div>
  );
}